import {NotFound} from "../../../routing/pages/NotFound";
import LoadingLogoSpinner from "../../../components/loading-pie/LoadingLogoSpinner.tsx";
import {MainComponent} from "../../../components/main/MainComponent";
import React, {useEffect, useState} from "react";
import {useStores} from "../../../stores";
import type {RouteWrapperProps} from "../RouteWrapperProps";
import {DatasetUpdatedLandingPage} from "../../../routing/pages/DatasetUpdatedLandingPage";
import {observer} from "mobx-react-lite";

export const SingleDatabagWrapped: React.FC<RouteWrapperProps> = observer(({children, state}) => {
    const {authStore, bagStore, bagLoadingStore} = useStores();
    const isNoData = state.dataType === 'no_data';
    const noBag = !bagStore.bag;

    const [showLoading, setShowLoading] = useState(false)
    useEffect(() => {
        if (noBag) {
            const timeout = setTimeout(() => setShowLoading(true), 2000);
            return () => clearTimeout(timeout);
        } else {
            setShowLoading(false);
        }
    }, [noBag]);

    // Centred only for the dataset spinner: a page without data (e.g. approvals) shows no spinner, and opened
    // with no dataset selected its content would otherwise be centred too.
    return <MainComponent state={state} centeredContent={showLoading && !isNoData}>
        {
            isNoData
                ? children
                : (
                    bagLoadingStore.bagNotFound
                        ? <NotFound
                            msg={<>We are not able to find this dataset anymore<br/>Please select another dataset</>}/>
                        : noBag
                            ? (showLoading ? <LoadingLogoSpinner/> : null)
                            : authStore.isMithraStaff || !bagStore.bag?.hidden
                                ? children
                                : <DatasetUpdatedLandingPage/>
                )
        }
    </MainComponent>
})
